//
// Load jQuery plugins
//

import '@popperjs/core';
import 'bootstrap';
import 'arrive';

//
//  Load custom js
//

import theme from './_theme';


//
//  Load Blocks
//
import cardsSlider from './blocks/_cards-slider'
